'use client'
import {
  ContentfulMedia_default,
  ThemeButton_default
} from "./chunk-XIZE6A22.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/section/DecoratedSection.tsx
import { twMerge as twMerge3 } from "tailwind-merge";

// src/components/section/DecoratedRoundedSection.tsx
import { twMerge as twMerge2 } from "tailwind-merge";

// src/components/section/Subtitle.tsx
import { Typography } from "@wbk/ui";
import { Link } from "@wbk/config";
import { twMerge } from "tailwind-merge";
import { jsx, jsxs } from "react/jsx-runtime";
var SectionSubtitle = ({ section, className }) => {
  var _a, _b;
  const subtitle = section == null ? void 0 : section.subtitle;
  const button = (_b = (_a = section == null ? void 0 : section.linksCollection) == null ? void 0 : _a.items) == null ? void 0 : _b[0];
  if (!subtitle && !button) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", { className: twMerge("space-y-2", className), children: [
    section.subtitle && /* @__PURE__ */ jsx(Typography, { children: section.subtitle }),
    button && /* @__PURE__ */ jsx(ThemeButton_default, { as: Link, href: button.href, theme: button.theme, shape: button.shape, children: /* @__PURE__ */ jsx(Typography, { children: button.label }) })
  ] });
};
var Subtitle_default = SectionSubtitle;

// src/components/section/DecoratedRoundedSection.tsx
import { Fragment, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var DecoratedRoundedSection = (_a) => {
  var _b = _a, {
    section,
    children,
    as: Comp = "section"
  } = _b, props = __objRest(_b, [
    "section",
    "children",
    "as"
  ]);
  var _a2, _b2, _c, _d;
  const topDecorator = section == null ? void 0 : section.topDecorator;
  const bottomDecorator = section == null ? void 0 : section.bottomDecorator;
  const hasDecorator = !!topDecorator || !!bottomDecorator;
  const logo = section == null ? void 0 : section.logo;
  const bg = (_b2 = (_a2 = section == null ? void 0 : section.sectionBackgroundsCollection) == null ? void 0 : _a2.items) == null ? void 0 : _b2[0];
  const titleColor = section == null ? void 0 : section.titleColor;
  const bgColor = section == null ? void 0 : section.backgroundColor;
  const innerBgColor = section == null ? void 0 : section.innerBackgroundColor;
  const topPadding = (_c = section == null ? void 0 : section.topPadding) != null ? _c : 48;
  const bottomPadding = (_d = section == null ? void 0 : section.bottomPadding) != null ? _d : 48;
  return /* @__PURE__ */ jsx2(
    Comp,
    __spreadProps(__spreadValues({
      id: section.id
    }, props), {
      className: "space-y-L relative",
      style: { backgroundColor: bgColor, paddingTop: topPadding, paddingBottom: bottomPadding },
      children: /* @__PURE__ */ jsxs2(
        "div",
        {
          "data-inner": !!innerBgColor,
          "data-top-decorator": !!topDecorator,
          "data-bottom-decorator": !!bottomDecorator,
          className: "group data-[inner=false]:container md:container",
          children: [
            topDecorator && /* @__PURE__ */ jsx2(
              "div",
              {
                className: "bg-repeat-x",
                style: { backgroundImage: `url(${topDecorator.url})`, height: topDecorator.height }
              }
            ),
            /* @__PURE__ */ jsxs2(
              "div",
              {
                className: twMerge2(
                  "space-y-L md:rounded-L relative rounded-none group-data-[inner=true]:container group-data-[inner=true]:py-8",
                  "overflow-hidden group-data-[bottom-decorator=true]:rounded-b-none group-data-[top-decorator=true]:rounded-t-none",
                  props.className
                ),
                style: __spreadValues({ color: titleColor, backgroundColor: innerBgColor }, props.style),
                children: [
                  bg && /* @__PURE__ */ jsx2(
                    ContentfulMedia_default,
                    {
                      media: bg,
                      className: "absolute top-0 h-full w-full object-cover object-top ltr:left-0 rtl:right-0",
                      autoPlay: true,
                      loop: true,
                      muted: true,
                      playsInline: true,
                      disablePictureInPicture: true,
                      ratio: "3x1",
                      placeholder: true
                    }
                  ),
                  hasDecorator ? /* @__PURE__ */ jsxs2("div", { className: "space-y-L", children: [
                    logo && /* @__PURE__ */ jsx2("div", { className: "relative", children: /* @__PURE__ */ jsx2(ContentfulMedia_default, { media: logo }) }),
                    children
                  ] }) : /* @__PURE__ */ jsxs2(Fragment, { children: [
                    logo && /* @__PURE__ */ jsx2("div", { className: "relative", children: /* @__PURE__ */ jsx2(ContentfulMedia_default, { media: logo }) }),
                    children
                  ] }),
                  /* @__PURE__ */ jsx2(Subtitle_default, { section, className: "container md:hidden [&>a]:w-full" })
                ]
              }
            ),
            bottomDecorator && /* @__PURE__ */ jsx2(
              "div",
              {
                className: "bg-repeat-x",
                style: {
                  backgroundImage: `url(${bottomDecorator.url})`,
                  height: bottomDecorator.height
                }
              }
            )
          ]
        }
      )
    })
  );
};
var DecoratedRoundedSection_default = DecoratedRoundedSection;

// src/components/section/DecoratedSection.tsx
import { Fragment as Fragment2, jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var CONTAINER_CLASS = {
  default: "container",
  half: "container-1/2",
  fullwidth: "container !max-w-full"
};
var DecoratedSection = (_a) => {
  var _b = _a, {
    section,
    children,
    as: Comp = "section",
    groupClassName
  } = _b, props = __objRest(_b, [
    "section",
    "children",
    "as",
    "groupClassName"
  ]);
  var _a2, _b2, _c, _d;
  const topDecorator = section == null ? void 0 : section.topDecorator;
  const bottomDecorator = section == null ? void 0 : section.bottomDecorator;
  const hasDecorator = !!topDecorator || !!bottomDecorator;
  const logo = section == null ? void 0 : section.logo;
  const bg = (_b2 = (_a2 = section == null ? void 0 : section.sectionBackgroundsCollection) == null ? void 0 : _a2.items) == null ? void 0 : _b2[0];
  const titleColor = section == null ? void 0 : section.titleColor;
  const bgColor = section == null ? void 0 : section.backgroundColor;
  const topPadding = (_c = section == null ? void 0 : section.topPadding) != null ? _c : 48;
  const bottomPadding = (_d = section == null ? void 0 : section.bottomPadding) != null ? _d : 48;
  const container = (section == null ? void 0 : section.container) || "default";
  if (container === "rounded") {
    return /* @__PURE__ */ jsx3(DecoratedRoundedSection_default, __spreadProps(__spreadValues({ section, as: Comp }, props), { children }));
  }
  return /* @__PURE__ */ jsxs3(
    Comp,
    __spreadProps(__spreadValues({
      id: section.id
    }, props), {
      className: twMerge3("space-y-L relative", groupClassName),
      style: { backgroundColor: bgColor, paddingTop: topPadding, paddingBottom: bottomPadding },
      children: [
        bg && /* @__PURE__ */ jsx3(
          ContentfulMedia_default,
          {
            media: bg,
            className: "absolute top-0 h-full w-full object-cover object-top ltr:left-0 rtl:right-0",
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true,
            disablePictureInPicture: true,
            ratio: "3x1",
            placeholder: true
          }
        ),
        /* @__PURE__ */ jsxs3(
          "div",
          {
            className: twMerge3("space-y-L relative", CONTAINER_CLASS[container], props.className),
            style: __spreadValues({ color: titleColor }, props.style),
            children: [
              topDecorator && /* @__PURE__ */ jsx3(
                "div",
                {
                  className: "bg-repeat-x",
                  style: { backgroundImage: `url(${topDecorator.url})`, height: topDecorator.height }
                }
              ),
              hasDecorator ? /* @__PURE__ */ jsxs3(
                "div",
                {
                  "data-top-decorator": !!topDecorator,
                  "data-bottom-decorator": !!bottomDecorator,
                  className: "space-y-L data-[bottom-decorator=true]:pb-14 data-[top-decorator=true]:pt-14",
                  children: [
                    logo && /* @__PURE__ */ jsx3("div", { className: "relative", children: /* @__PURE__ */ jsx3(ContentfulMedia_default, { media: logo }) }),
                    children
                  ]
                }
              ) : /* @__PURE__ */ jsxs3(Fragment2, { children: [
                logo && /* @__PURE__ */ jsx3("div", { className: "relative", children: /* @__PURE__ */ jsx3(ContentfulMedia_default, { media: logo }) }),
                children
              ] }),
              bottomDecorator && /* @__PURE__ */ jsx3(
                "div",
                {
                  className: "bg-repeat-x",
                  style: {
                    backgroundImage: `url(${bottomDecorator.url})`,
                    height: bottomDecorator.height
                  }
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx3(Subtitle_default, { section, className: "container md:hidden [&>a]:w-full" })
      ]
    })
  );
};
var DecoratedSection_default = DecoratedSection;

export {
  Subtitle_default,
  DecoratedSection_default
};
//# sourceMappingURL=chunk-BK6LVH5K.mjs.map